import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getFirebaseApp } from './firebaseConfig';

const storage = getStorage(getFirebaseApp());

export const uploadPostImage = async (file, userId, postName, idx) => {
  const ext = file.name.split('.').pop();
  const path = `posts/${userId || 'anonymous'}/${postName || 'post'}_${Date.now()}_${idx}.${ext}`;
  const storageRef = ref(storage, path);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
};
